var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.3L14.4 20.8C12.4 18.9 11 17.7 11 16.2C11 15 12 14 13.2 14C13.9 14 14.6 14.3 15 14.8C15.4 14.3 16.1 14 16.8 14C18 14 19 14.9 19 16.2C19 17.7 17.6 18.9 15.6 20.8L15 21.3ZM14 0C15.1 0 16 0.9 16 2V11.08L15 11L14 11.08V2H9V10L6.5 7.75L4 10V2H2V18H9.08C9.2 18.72 9.45 19.39 9.8 20H2C0.9 20 0 19.1 0 18V2C0 0.9 0.9 0 2 0H14Z",
    fill: "#B9B4CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterests);
export default __webpack_public_path__ + "static/media/interests.59e7a3dc0fb8fab0e929783a0c5b71ed.svg";
export { ForwardRef as ReactComponent };